export const environment = {
  production: true,
  baseUrl: 'https://reliefdev.rnel.com/mcs_test/',
  apmUrl: 'https://appsdev.rnel.com/apmrum/',
  appName: 'NEI_AJ_MATONE',
  env: 'dev',
  mfeBaseUrl: '/reports/',
  appUri: 'http://localhost:4200/',
  rSevaUrl: 'https://sevafirst.ril.com/',
  EMP_INFO_ENDPOINT:
    'https://rpmg1.ril.com/camsapi/CU_NC_EmployeeInfo/1.0.0/api/UserImage',
  sso: 'U2FsdGVkX1+L82R0KLN/Xb9uCEvwdKCZ66ytB8IHrSik1JzAhXr2TkgzPzjk5zYep2pzAbJFUBXpjWKBDE25bVUbBgA7K8Mkcv3mQFO3PYaufEHjm8FzCUuY4tweOU34cTJqMA7SyyrHE6MgXSxKaAyWVbv7JZFy5gG/fSt0Jeml8ZMsi1EgKmUHZE5lA3mt2BonVwPnEP0tWZnbESaWV5uSb9Pax6ced6etWhQOyUf6fdBgk6E9nUaH/L3O1bqOistir2RTWwmC7Zg1hRUIujz0H2GgY5e0TTkmGc0Zt4ZxXi3jlnSCHCX+XviNI4tugYSmoyaUmZAR5XF4VYYYSCRZVpB8lPuUc+FoJAtDykzdG2bMP/uqzqtwYH04UK50/Uf9nLlNVAJ5WJXEvLusK3sLGPmD+95Io2e2QQhbpYyVgzIr+hDCDpvZJL9ENK+OlVwpfeqRWUWe1tzFyMhvQ+7kpQ4Q16VKDoGZhktSqamzpfFW3+ua9zrUDOg0s4RDrIyLoUeS5P+HxnPvZxungOcLOgZ1J0OFw/3yn8seO6jGZbSwvAp9JAS0dFIbCfnl2IZDk1EolwFmY9y2RWUBxBziqzi+Udbc8vra7zSqIVzP9siLiwwdZmQpQ4xsT8oxG7DUs0rtYtJZIlN7VAWhcBDiMThvlgUDZFW+q82PvYeFauO1xyMruZNtkDdfmuW8vSEq1N6jXLDeESKCKNyIfZTocv9fJ2kH+6aTCyrM2MX5GPHwRHdqU3A8QT3OWgpEAIKNdqMxqBT6FbA17FCkhXUCxbLkQknoYVT7sgtr4pTuQgsA+BXKVjxitF89lcmf6vcjZoJ0jOx5Z5ztf2Wvj9Tz1vh2fP22eKVCb8rITQpd64xsLQPBOWPMbinAz07N8wstCa+6cnQp8HtOPF2Fk7JhHrSB1QWeta3dnRfbvRUXaRAgC2ytSEwMVTYZFD+YK4Uz34T6YP8IImbQB4gZLaofzxCsAEgA+NNmpySC+kk=',
  cookiesso: {
    serverUrl: 'https://sso.ril.com/',
  },
  opentelemetryConfig: {
    commonConfig: {
      console: true,
      production: false,
      logBody: true,
      serviceName: 'nei-aj-matone',
      probabilitySampler: '0.7',
      logLevel: 9999,
      resourceAttributes: {
        env: 'dev',
        'app.version': '1.0.0',
      },
    },
    batchSpanProcessorConfig: {
      maxQueueSize: '2048',
      maxExportBatchSize: '512',
      scheduledDelayMillis: '5000',
      exportTimeoutMillis: '30000',
    },
    otelcolConfig: {
      url: 'https://gepp-tempo-v2.jio.ril.com/v1/traces',
    },
    jaegerPropagatorConfig: {
      customHeader: 'custom-header',
    },
  },
};
